import React, { useState } from 'react';
import { updateTicket } from "../../../../globals/backend/ticketsApi";

function InserisciOffertaOrdine({ data, handleClose, handleSuccess, handleError }) {
    const [offerta, setOfferta] = useState(data.Offerta);
    const [ordine, setOrdine] = useState(data.Ordine);

    const handleSave = async () => {
        const conferma = window.confirm("Sei sicuro di voler salvare l'offerta e l'ordine?");
        if (conferma) {
            try {
                await updateTicket(data.ID, {
                    Offerta: offerta,
                    Ordine: ordine
                });
                handleSuccess();
                handleClose();
            } catch (error) {
                console.error('Errore durante la richiesta:', error);
                handleError();
            }
        }
    };

    return (
        <>
            <div className='divApertoTicket'>
                <div className="OffertaModalMainDiv">
                    <span onClick={handleClose} className='chiudiDivxTicket'>
                        &times;
                    </span>
                    <div>
                        <label>
                            Offerta:
                            <input
                                type="text"
                                value={offerta}
                                onChange={(e) => setOfferta(e.target.value)}
                            />
                        </label>
                    </div>
                    <div>
                        <label>
                            Ordine:
                            <input
                                type="text"
                                value={ordine}
                                onChange={(e) => setOrdine(e.target.value)}
                            />
                        </label>
                    </div>
                    <button onClick={handleSave}>Save</button>
                </div>
            </div>
        </>
    );
};

export default InserisciOffertaOrdine;
